var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f-section',{staticClass:"section-header"},[_c('f-container',[_c('n-link',{staticClass:"header-link",attrs:{"to":"/"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }